module.exports = __webpack_public_path__ + "img/P150T_weapon_58.4905e5da.png";